import React, { useEffect, useState } from "react";
import { Outlet, Routes } from "react-router-dom";
import SideBar from "../../components/Navbars/SideBar";
import centerDashRoutes from "../../router/routes/centerDash/centerDash.routes";

export default function CenterDash() {

    const baseUrl = window.location.pathname.split("/").splice(0, 3).join("/");

    return (
        <>
            <SideBar
                routes={centerDashRoutes}
                panelName="Center"
                navUrlPos={3}
                baseUrl={baseUrl+"/"}
            />
            <Outlet />
        </>
    );
}
